
export const environment = {
  production: false,
  baseUrl :'https://api.mycarriershield.com/'
  // 'https://carrier-sheild-1c42d504dd74.herokuapp.com/',
};

